import classNames from 'classnames';
import {
  CheckboxButton as ReactAriaCheckboxButton,
  CheckboxField as ReactAriaCheckboxField,
} from 'react-aria-components/Checkbox';

import Icon from '../../../app/shared/components/Icon/Icon';
import { Focusable, Tooltip, TooltipTrigger } from '../../../app/shared/components/Tooltip/Tooltip';
import { IncludeNetPriceTranslation } from '../../localization/ModuleTranslation';
import css from './IncludeNetPriceCheckbox.css';

interface IncludeNetPriceCheckboxProps {
  isSelected: boolean;
  isAvailable: boolean;
  onChange: (isSelected: boolean) => void;
  translation: IncludeNetPriceTranslation;
  className?: string;
}

const IncludeNetPriceCheckbox = ({
  className,
  isAvailable,
  isSelected,
  onChange,
  translation,
}: IncludeNetPriceCheckboxProps) => {
  const checkbox = (
    <ReactAriaCheckboxField isSelected={isAvailable && isSelected} isDisabled={!isAvailable} onChange={onChange}>
      <ReactAriaCheckboxButton className={css.button}>
        {(renderProps) => (
          <>
            <span className={css.indicator}>
              {renderProps.isSelected && <Icon name="check" className={css.icon} />}
            </span>
            {translation.label}
          </>
        )}
      </ReactAriaCheckboxButton>
    </ReactAriaCheckboxField>
  );

  if (isAvailable) {
    return <div className={classNames(css.root, className)}>{checkbox}</div>;
  }

  // A disabled checkbox takes no hover or focus, so the reason is attached to an element around it.
  return (
    <TooltipTrigger>
      <Focusable>
        <span className={classNames(css.root, className)} tabIndex={0}>
          {checkbox}
        </span>
      </Focusable>
      <Tooltip placement="top" offset={8}>
        {translation.noAgreementsReason}
      </Tooltip>
    </TooltipTrigger>
  );
};

export default IncludeNetPriceCheckbox;
